class KlProductMedia extends HTMLElement {
  connectedCallback() {
    this.mainImage = this.querySelector('[data-kl-main-image]');
    this.anchorHotspot = this.querySelector('[data-kl-anchor-hotspot]');
    this.buttons = Array.from(this.parentElement?.querySelectorAll('[data-kl-media-button]') || []);

    for (const button of this.buttons) {
      button.addEventListener('click', this.handleMediaChange);
    }
  }

  disconnectedCallback() {
    for (const button of this.buttons || []) {
      button.removeEventListener('click', this.handleMediaChange);
    }
  }

  handleMediaChange = (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement) || !(this.mainImage instanceof HTMLImageElement)) return;

    const nextSource = button.dataset.klMediaSrc;
    if (!nextSource) return;

    const isComposite = button.dataset.klComposite === 'true';

    this.mainImage.style.opacity = '0';
    window.setTimeout(() => {
      this.mainImage.src = nextSource;
      this.mainImage.srcset = '';
      this.mainImage.alt = button.dataset.klMediaAlt || '';
      this.classList.toggle('is-composite', isComposite);
      if (this.anchorHotspot instanceof HTMLAnchorElement) {
        this.anchorHotspot.hidden = !isComposite;
      }
      this.mainImage.style.opacity = '1';
    }, 120);

    for (const mediaButton of this.buttons) {
      const isActive = mediaButton === button;
      mediaButton.classList.toggle('is-active', isActive);
      mediaButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  };
}

if (!customElements.get('kl-product-media')) {
  customElements.define('kl-product-media', KlProductMedia);
}
